const cache = new Map<string, Intl.DateTimeFormat>();

/**
 * A UTC `Intl.DateTimeFormat` for calendar dates, created once per locale and option set.
 * Building one is slow (about a tenth of a millisecond), and the day and week views format dozens of dates per render.
 */
export function utcDateFormatter(locale: string, options: Intl.DateTimeFormatOptions): Intl.DateTimeFormat {
  const key = `${locale}|${JSON.stringify(options)}`;
  const known = cache.get(key);
  if (known !== undefined) return known;
  const created = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', ...options });
  cache.set(key, created);
  return created;
}
